// extracted by mini-css-extract-plugin
module.exports = {"failurePageWrapper":"failurePage_failurePageWrapper__1scy0","content":"failurePage_content__1c42R"};